<template>
  <div id="app">
    <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0">
    <router-view/>
  </div>
</template>


<script>
export default {
  name: 'App'
}
window.onload = function() {
  document.addEventListener('touchstart', function(event) {
    if (event.touches.length > 1) {
      event.preventDefault()
    }
  })
  document.addEventListener('gesturestart', function(event) {
    event.preventDefault()
  })
}
</script>

<style lang="scss">
body{
  margin:0;
  /* padding:0 10px; */
  background-color:#fff!important;
}
#app {
  /* font-family: 'Avenir', Helvetica, Arial, sans-serif; */
  font-family: PingFangSC-Regular, sans-serif;
  font-weight:400;
  /* -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50; */
  /* margin-top: 60px; */
}
.mint-tab-item-label{
  font-size:15px!important;
}
.mint-cell-wrapper{
  background:none!important;
}
/* 订单列表商品名称样式改写 */
// .mint-cell-text{
//   width:160px;
//   color:#666;
//   vertical-align:top!important;
//   margin-top:5px;
//   margin-left:8px;
//   font-size:14px;
//   display: inline-block!important;
//   display: -webkit-inline-box!important;
//   overflow: hidden!important;
//   text-overflow: ellipsis!important;
//   word-wrap: break-word!important;
//   white-space: normal !important;
//   -webkit-line-clamp: 2!important;
//   -webkit-box-orient: vertical!important;
//   line-height:22px;
// }
// .mint-cell-title{
//   position: relative;
//   .mint-cell-label{
//     width:160px;
//     color:#b5b5b5;
//     position:absolute;
//     bottom:20px;
//     left:115px;
//     font-size:13px;
//   }
// }

/* 订单列表商品价格样式改写 */
// .mint-cell-value{
//   position:relative;
//   height:95px;
//   display:block;
//   margin-top:5px;
//   text-align: center;
//   span{
//     display:block;
//   }
//   .normal-price{
//     color:#333;
//     font-size:15px;
//   }
//   .vip-price{
//     color:#FB002E;
//     font-size:16px;
//     line-height:22px;
//   }
//   .original-price{
//     color:#333;
//     font-size:13px;
//     line-height:18px;
//     text-decoration: line-through;
//   }
//   .amount{
//     position: absolute;
//     bottom:20px;
//     right:0;
//     font-size:13px;
//     color:#333;
//   }
// }
//订单列表和订单详情 商品排列样式
.store-content{
    // padding:0 10px;
    &::after{
        content:'';
        display:block;
        width:100%;
        height:9px;
        background-color:#eee;
    }
    &:last-child{
        &::after{
            height:0;
        }
    }
    .store-title{
        margin:25px 10px 0;
        padding-bottom:9px;
        font-size:14px;
        line-height:20px;
        border-bottom:1px solid #eee;
        &::before{
            content:'';
            display:inline-block;
            width:4px;
            height:12px;
            background-color:#D7AD81;
            margin-right:9px;
            vertical-align: middle;
        }
        .store-name{
            color:#333;
        }
        .order-statue{
            color:#CE8B44;
            float:right;
        }
    }
    .mint-cell{
          background:none;
          margin-top:12px;
        .mint-cell-title{
            img{
                width:100px;
                height:100px;
            }
        }
        
    }
    .total-info{
        margin:12px 10px;
        line-height:22px;
        text-align:right;
        padding-bottom:10px;
        border-bottom:1px solid #eee;
        font-size:13px;
        color:#262626;
        .big-price{
            font-size:16px;
        }
    }
    .total-price{
      margin:12px 10px;
      font-size:13px;
      border-top:1px solid #eee;
      border-bottom:1px solid #eee;
      line-height:22px;
      padding:11px 0;
      
      .right{
        float:right;
        .big-price{
            font-size:16px;
        }
      }
      .right-total{
        color:#FB002E;
      }
    }
    .operate-btns{
        text-align:right;
        margin:4px 0 16px;
        .mint-button{
            background:none;
            border-color:#9D9D9D;
            height:28px;
            line-height:28px;
            border-radius:14px;
            font-size:13px;
            color:#333;
            padding:0 10px;
            margin-right:10px;
        }
    }
} 
// 弹框
.mint-msgbox-btn{
  font-size:14px;
}
.mint-msgbox-confirm {
    color: #D7AD81;
}


.product_list{
  padding: 12px;
  .left{
    float:left;
      img{
          width:100px;
          height:100px;
      }
  }
  .right{
      position:relative;
      float:right;
      width: 68%;
      margin-left: 15px;
      span{
          display:inline-block;
      }
      .top{
          // display:flex;
          // justify-content: space-between;
          // flex-wrap :nowrap;
          margin-top:5px;
          height:44px;
          width:100%;
          .title{
              width:160px;
              color:#666;
              font-size:14px;
              display: -webkit-inline-box;
              overflow: hidden;
              text-overflow: ellipsis;
              word-wrap: break-word;
              white-space: normal;
              -webkit-line-clamp: 2;
              line-clamp:2;
              -webkit-box-orient: vertical;
              box-orient: vertical;
              line-height:22px;
              height:44px;
          }
          .normal-price{
              color:#333;
              font-size:15px;
              height:44px;
              float:right;
              display:block;
          }
          .vip-price{
              color:#FB002E;
              font-size:16px;
              line-height:22px;
              display:block;
          }
          .original-price{
              color:#333;
              font-size:13px;
              line-height:18px;
              text-decoration: line-through;
              display:block;
          }
      }
      .bottom{
          width:100%;
          position:absolute;
          bottom:10px;
          left:0;
          .spec{
              font-size:13px;
              color:#B5B5B5;
              float:left;
          }
          .amount{
              font-size:13px;
              color:#333;
              text-align:right;
              float:right;
          }
      }
      
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue